/* Design system (20 ottobre 2026).
   1) Scheda prodotto: l'immagine principale scorre (frecce, puntini, swipe) tra tutte le foto del prodotto; toccando una foto,
      principale o miniatura, si apre a schermo intero con scorrimento, tasti freccia ed Esc. Il tema non aveva ingrandimento.
   2) Card prodotto: le foto con bordi bianchi incorporati nei pixel (foto più stretta dentro un quadrato bianco) vengono
      ingrandite quanto basta per arrivare ai bordi della card. I fondi bianchi dei prodotti scontornati restano invariati. */
(function () {
  /* testi dai file lingua del tema (locales, chiave ds.gallery), modificabili da Admin → Lingue */
  var T = Object.assign({ enlarge: 'Ingrandisci immagine', prev: 'Foto precedente', next: 'Foto successiva', close: 'Chiudi', dialog: 'Foto del prodotto' }, typeof window.dsStrings === 'object' ? window.dsStrings : {});
  var ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M15 5l-7 7 7 7"/></svg>';
  var ARROW_R = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 5l7 7-7 7"/></svg>';
  var CLOSE = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  function bigSrc(img) {
    var best = img.currentSrc || img.src, w = 0;
    (img.getAttribute('srcset') || '').split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/); var n = parseInt(p[1], 10);
      if (p[0] && n > w) { w = n; best = p[0]; }
    });
    return best;
  }

  /* scorrimento dell'immagine principale: touch events sul telefono (provati su Safari iOS), trascinamento del mouse su desktop.
     Dopo uno scorrimento il clic che segue non apre l'ingrandimento */
  function swipe(el, onLeft, onRight, onTap) {
    var x0 = null, y0 = null, dragged = false;
    function start(x, y) { x0 = x; y0 = y; dragged = false; }
    function move(x) { if (x0 !== null && Math.abs(x - x0) > 10) dragged = true; }
    function end(x, y) {
      if (x0 === null) return false;
      var dx = x - x0, dy = y - y0; x0 = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { (dx < 0 ? onLeft : onRight)(); return true; }
      return false;
    }
    el.addEventListener('touchstart', function (e) { start(e.touches[0].clientX, e.touches[0].clientY); }, { passive: true });
    el.addEventListener('touchmove', function (e) { move(e.touches[0].clientX); }, { passive: true });
    el.addEventListener('touchend', function (e) {
      var x = e.changedTouches[0].clientX, y = e.changedTouches[0].clientY, sx = x0, sy = y0;
      if (end(x, y)) { e.preventDefault(); return; }
      /* tocco fermo sull'immagine (non sulle frecce): apre l'ingrandimento; Safari iOS non genera sempre il clic */
      if (onTap && sx !== null && Math.abs(x - sx) < 10 && Math.abs(y - sy) < 10 && !e.target.closest('button')) { e.preventDefault(); onTap(); }
    });
    el.addEventListener('pointerdown', function (e) { if (e.pointerType === 'mouse' && e.button === 0) start(e.clientX, e.clientY); });
    el.addEventListener('pointermove', function (e) { if (e.pointerType === 'mouse') move(e.clientX); });
    el.addEventListener('pointerup', function (e) { if (e.pointerType === 'mouse') end(e.clientX, e.clientY); });
    el.addEventListener('click', function (e) { if (dragged) { e.preventDefault(); e.stopPropagation(); dragged = false; } }, true);
    el.addEventListener('dragstart', function (e) { e.preventDefault(); });
  }

  function gallery() {
    var wrap = document.querySelector('.product__media-wrapper');
    if (!wrap) return;
    var mainItem = wrap.querySelector(':scope slider-component > .product__media-item');
    var mainImg = mainItem && mainItem.querySelector('.product__modal-opener--image img');
    if (!mainImg) return;
    var thumbs = Array.prototype.slice.call(wrap.querySelectorAll('.product__slider .splide__slide:not(.splide__slide--clone)'))
      .filter(function (li) { return li.querySelector('.product__modal-opener--image img'); });
    var items = [{ src: bigSrc(mainImg), small: mainImg.currentSrc || mainImg.src, srcset: mainImg.getAttribute('srcset'), alt: mainImg.alt, li: null }];
    thumbs.forEach(function (li) {
      var im = li.querySelector('img');
      items.push({ src: bigSrc(im), small: im.currentSrc || im.src, srcset: im.getAttribute('srcset'), alt: im.alt, li: li });
    });
    var current = 0;
    var box = mainItem.querySelector('.product__media');
    box.classList.add('ds-gallery-main');
    box.setAttribute('role', 'button');
    box.setAttribute('tabindex', '0');
    box.setAttribute('aria-label', T.enlarge);

    items[0].small = mainImg.getAttribute('src');
    var dots = null, shown = 0;
    function show(i) {
      current = (i + items.length) % items.length;
      var it = items[current];
      if (current !== shown) {
        shown = current;
        if (it.srcset) mainImg.setAttribute('srcset', it.srcset); else mainImg.removeAttribute('srcset');
        mainImg.setAttribute('src', it.small);
      }
      mainImg.alt = it.alt;
      if (dots) Array.prototype.forEach.call(dots.children, function (d, k) { d.classList.toggle('is-active', k === current); });
      items.forEach(function (x, k) { if (x.li) x.li.classList.toggle('ds-is-current', k === current); });
    }
    if (items.length > 1) {
      var prev = document.createElement('button'); prev.type = 'button'; prev.className = 'ds-gallery-nav ds-gallery-nav--prev'; prev.innerHTML = ARROW; prev.setAttribute('aria-label', T.prev);
      var next = document.createElement('button'); next.type = 'button'; next.className = 'ds-gallery-nav ds-gallery-nav--next'; next.innerHTML = ARROW_R; next.setAttribute('aria-label', T.next);
      dots = document.createElement('div'); dots.className = 'ds-gallery-dots';
      items.forEach(function () { dots.appendChild(document.createElement('span')); });
      /* controlli fuori da .media: il tema stende a tutta area ogni figlio diretto di .media */
      mainItem.classList.add('ds-gallery-holder');
      mainItem.appendChild(prev); mainItem.appendChild(next); mainItem.appendChild(dots);
      swipe(mainItem, function () { show(current + 1); }, function () { show(current - 1); }, function () { open(current); });
      prev.addEventListener('click', function (e) { e.stopPropagation(); show(current - 1); });
      next.addEventListener('click', function (e) { e.stopPropagation(); show(current + 1); });
      show(0);
    }
    box.addEventListener('click', function () { open(current); });
    box.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(current); } });
    thumbs.forEach(function (li) {
      li.addEventListener('click', function (e) {
        e.preventDefault(); e.stopPropagation();
        var k = items.findIndex(function (x) { return x.li === li; });
        show(k); open(k);
      }, true);
    });

    /* vista ingrandita: una striscia a scorrimento orizzontale nativo (scroll-snap), quindi lo swipe è quello del browser */
    var lb, track, lbCount, last = null;
    function build() {
      lb = document.createElement('div'); lb.className = 'ds-lightbox'; lb.hidden = true;
      lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', T.dialog);
      lb.innerHTML = '<div class="ds-lightbox__track"></div><button type="button" class="ds-lightbox__close" aria-label="' + T.close + '">' + CLOSE + '</button>' +
        (items.length > 1 ? '<button type="button" class="ds-lightbox__prev" aria-label="' + T.prev + '">' + ARROW + '</button><button type="button" class="ds-lightbox__next" aria-label="' + T.next + '">' + ARROW_R + '</button>' : '') +
        '<div class="ds-lightbox__count" aria-live="polite"></div>';
      track = lb.querySelector('.ds-lightbox__track');
      items.forEach(function (it) {
        var sl = document.createElement('div'); sl.className = 'ds-lightbox__slide';
        var im = document.createElement('img'); im.alt = it.alt; im.dataset.src = it.src; im.draggable = false;
        sl.appendChild(im); track.appendChild(sl);
        sl.addEventListener('click', function (e) { if (e.target === sl) close(); });
      });
      document.body.appendChild(lb);
      lbCount = lb.querySelector('.ds-lightbox__count');
      lb.querySelector('.ds-lightbox__close').addEventListener('click', close);
      if (items.length > 1) {
        lb.querySelector('.ds-lightbox__prev').addEventListener('click', function () { go(current - 1, true); });
        lb.querySelector('.ds-lightbox__next').addEventListener('click', function () { go(current + 1, true); });
      }
      var t = null;
      track.addEventListener('scroll', function () {
        clearTimeout(t);
        t = setTimeout(function () { var k = Math.round(track.scrollLeft / track.clientWidth); if (k !== current) { show(k); render(); } }, 80);
      }, { passive: true });
      document.addEventListener('keydown', function (e) {
        if (lb.hidden) return;
        if (e.key === 'Escape') close();
        else if (e.key === 'ArrowRight') go(current + 1, true);
        else if (e.key === 'ArrowLeft') go(current - 1, true);
      });
    }
    function load(k) { var im = track.children[k] && track.children[k].querySelector('img'); if (im && !im.src) im.src = im.dataset.src; }
    function render() { load(current); load(current + 1); load(current - 1); lbCount.textContent = items.length > 1 ? (current + 1) + ' / ' + items.length : ''; }
    function go(i, smooth) {
      show(i); render();
      track.scrollTo({ left: current * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    }
    function open(i) {
      if (!lb) build();
      last = document.activeElement;
      lb.hidden = false; document.documentElement.style.overflow = 'hidden';
      go(i, false);
      lb.querySelector('.ds-lightbox__close').focus();
    }
    function close() { lb.hidden = true; document.documentElement.style.overflow = ''; if (last && last.focus) last.focus(); }
  }

  function fitCards() {
    var imgs = document.querySelectorAll('.card__inner .media img, .product-card-image img');
    var canvas = document.createElement('canvas'), ctx = canvas.getContext('2d', { willReadFrequently: true });
    var S = 64; canvas.width = S; canvas.height = S;
    function check(img) {
      if (img.dataset.dsFit) return; img.dataset.dsFit = '1';
      try {
        ctx.clearRect(0, 0, S, S); ctx.drawImage(img, 0, 0, S, S);
        var d = ctx.getImageData(0, 0, S, S).data, white = function (x, y) { var i = (y * S + x) * 4; return d[i + 3] < 20 || (d[i] > 240 && d[i + 1] > 240 && d[i + 2] > 240); };
        var minX = S, maxX = -1, minY = S, maxY = -1, x, y;
        for (y = 0; y < S; y++) for (x = 0; x < S; x++) if (!white(x, y)) { if (x < minX) minX = x; if (x > maxX) maxX = x; if (y < minY) minY = y; if (y > maxY) maxY = y; }
        if (maxX < 0) return;
        var bw = maxX - minX + 1, bh = maxY - minY + 1, filled = 0;
        for (y = minY; y <= maxY; y++) for (x = minX; x <= maxX; x++) if (!white(x, y)) filled++;
        /* solo foto rettangolari (fondo pieno) con bordi bianchi incorporati; i prodotti scontornati hanno riempimento basso */
        if (filled / (bw * bh) < 0.9 || (bw > S * 0.94 && bh > S * 0.94)) return;
        /* ingrandimento contenuto (massimo 1,35): la foto si avvicina ai bordi senza tagliare troppo sopra e sotto */
        var scale = Math.min(Math.max(S / bw, S / bh), 1.35);
        var cx = (minX + bw / 2) / S * 100, cy = (minY + bh / 2) / S * 100;
        img.style.transformOrigin = cx + '% ' + cy + '%';
        img.style.transform = 'scale(' + scale.toFixed(3) + ')';
      } catch (e) { /* immagine non leggibile: invariata */ }
    }
    Array.prototype.forEach.call(imgs, function (img) {
      if (img.complete && img.naturalWidth) check(img); else img.addEventListener('load', function () { check(img); }, { once: true });
    });
  }

  /* categorie: con il testo aperto compare un secondo «Leggi meno» in cima al riquadro, che usa il pulsante originale */
  function readLessTop() {
    var box = document.querySelector('.collection-description');
    var orig = box && box.querySelector('.collection-description_buttons');
    var less = orig && orig.querySelector('.collection-description__read-less');
    if (!less || box.querySelector('.ds-readless-top')) return;
    var top = document.createElement('div'); top.className = 'ds-readless-top';
    var inner = document.createElement('div'); inner.setAttribute('role', 'button'); inner.tabIndex = 0;
    inner.innerHTML = '<span>' + less.textContent.trim() + '</span>';
    var caret = orig.querySelector('svg'); if (caret) { var c = caret.cloneNode(true); c.style.transform = 'rotate(180deg)'; inner.appendChild(c); }
    top.appendChild(inner); box.insertBefore(top, box.firstChild);
    function closeIt() { orig.querySelector('.collection-description__read-less').click(); box.scrollIntoView({ block: 'start', behavior: 'smooth' }); }
    inner.addEventListener('click', closeIt);
    inner.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); closeIt(); } });
  }

  function init() { gallery(); fitCards(); readLessTop(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  window.addEventListener('load', fitCards);
  document.addEventListener('shopify:section:load', fitCards);
})();
